export default __webpack_public_path__ + "static/media/suggest-an-integration.c0ce5c99.svg";